import React from "react";
import { Icons } from "@texada/ui";
import i18n from "i18n/i18n";

const SidebarFooter = props => {
  if (props.isHovered && !props.isMobile) {
    return (
      <div className="side_nav_exp-coll">
        {props?.SidebarMenuSwitch}
        <span className="collapse-container" onClick={props.handleHoverClick}>
          <Icons.KeyboardArrowRight />
          <span className="collapse_text">{i18n.t("expand_menu")}</span>
        </span>
      </div>
    );
  }
  return (
    <div className="side_nav_exp-coll">
      {props.isCollapsed ? (
        !props.isMobile && (
          <span className="collapse-container" onClick={props.handleHoverClick}>
            <Icons.KeyboardArrowRight />
          </span>
        )
      ) : (
        <>
          {props?.SidebarMenuSwitch}
          {!props.isMobile && (
            <span className="collapse-container" onClick={props.handleClick}>
              <Icons.KeyboardArrowLeft />
              <span className="collapse_text">{i18n.t("collapse_menu")}</span>
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default SidebarFooter;
